import { RouteConfig } from 'vue-router'

/**
 * term and condition customer module routes
 */
export const customerTermsRoutes: RouteConfig[] = [
  {
    path: '/customer-terms',
    name: 'customerTerms',
    component: () =>
      import(
        /* webpackChunkName: "TheCustomerTermsChunk" */ '@/modules/term-and-conditions/customer-terms/views/TheCustomerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsCustomerMetaTitle',
      parentRouteName: null
    }
  },
  {
    path: '/customer-terms/preview-details/:id',
    name: 'preview-customerTerms',
    component: () =>
      import(
        /* webpackChunkName: "ThePreviewCustomerTermsChunk" */ '@/modules/term-and-conditions/customer-terms/views/ThePreviewCustomerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsCustomerMetaTitle',
      parentRouteName: 'customerTerms'
    }
  },
  {
    path: '/customer-terms/upsert',
    name: 'upsert-customerTerms',
    component: () =>
      import(
        /* webpackChunkName: "TheUpsertCustomerTermsChunk" */ '@/modules/term-and-conditions/customer-terms/views/TheUpsertCustomerTerms.vue'
      ),
    meta: {
      title: 'navigations.termAndConditionsCustomerMetaTitle',
      parentRouteName: 'customerTerms'
    }
  }
]
